import { render, staticRenderFns } from "./uploadPhoto.vue?vue&type=template&id=41c44bd5&"
import script from "./uploadPhoto.vue?vue&type=script&lang=ts&"
export * from "./uploadPhoto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports